<script setup>
import { useI18n } from "vue-i18n";
const { t } = useI18n();

const title = t("home.advantagesCards.title");
const description = t("home.advantagesCards.subTitle");

const cookie = useCookie("authenticated");
const isLoggedIn = ref(computed(() => (cookie.value ? true : false)));
</script>
<template>
  <Title>{{ title }}</Title>
  <Meta name="description" :content="description" />
  <div class="container px-5 pt-6 md:pt-8">
    <HomepageTopBanner />
    <HomepageLogo />
  </div>

  <HomepageBenefitsSection />
  <HomepageGetCardSection />
  <HomepageReviews />
  <HomepageFaqs />
  <HomepageLoginBanner v-if="!isLoggedIn" />
</template>
